import { deviceService } from '../_services'

export const devices = {
  namespaced: true,
  state: {
    all: []
  },
  actions: {
    getAll ({ commit }, { perpage, page, sortby, descending }) {
      commit('getAllRequest')

      deviceService.getAll(perpage, page, sortby, descending)
        .then(
          customers => commit('getAllSuccess', customers),
          error => commit('getAllFailure', error)
        )
    }
  },
  mutations: {
    getAllRequest (state) {
      state.all = { loading: true }
    },
    getAllSuccess (state, devices) {
      state.all = { items: devices }
    },
    getAllFailure (state, error) {
      state.all = { error }
    }
  }
}
